import { lazy } from 'react'

export const AppInteractionLazy = lazy(() => import('./AppInteraction'))
